import { render } from "./ChatHistoryEntry.vue?vue&type=template&id=4d4a8c2e&ts=true"
import script from "./ChatHistoryEntry.vue?vue&type=script&lang=ts"
export * from "./ChatHistoryEntry.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__